export const isNumeric = (value) => {
    return value !== null && value !== '' && !isNaN(value) && isFinite(value);
};
